import Vue from 'vue'
import VueI18n from 'vue-i18n'
import EnLang from './en.json'
import JpLang from './jp.json'
import Constant from '../common/common-constant'

Vue.use(VueI18n)
const messages = {
  en: EnLang,
  jp: JpLang
}

export default new VueI18n({
  locale: Constant.DEFAULT_LANGUAGE,
  messages,
  fallbackLocale: 'en'
})



// WEBPACK FOOTER //
// ./src/lang/i18n.js